import { useEffect, useRef, useState } from 'react';
import { BiChevronDownCircle } from 'react-icons/bi';
import { FiSearch } from 'react-icons/fi';
import style from './style.module.scss';
// import {
//   container,
//   container_wrapper,
//   container_placehder,
//   DDContainer,
//   countrylist_wrapper,
//   countryDiv,
//   dail_code,
//   DDwrapper,
//   DDInput
// } from "./styles.module.scss";

import countryList from '../../../utils/countries.json';
import { useFormikContext } from 'formik';

export const CountryCodeSelect = ({ hideCountryCode, dialcodename, dialcodevalue, onChangeCode }) => {
  const [showDropDown, setShowDropDown] = useState(false);
  const [countries, setCountries] = useState(countryList);
  const [countriesOrderByActive, setCountriesOrderByActive] = useState([]);

  useEffect(() => {
    const activeCountries = ['Nigeria', 'Kenya', 'Ghana'];
    const squadCountries = countries.filter(country => activeCountries.includes(country.name));
    const otherCountries = countries.filter(country => !activeCountries.includes(country.name));

    //order by selected countries
    let order = {};
    for (let i = 0; i < activeCountries.length; i++) order[activeCountries[i]] = i;

    squadCountries.sort(function(a, b) {
      return order[a.name] - order[b.name] || a.name.localeCompare(b.name);
    });

    setCountriesOrderByActive([...squadCountries, ...otherCountries]);
  }, [countries]);

  const focusInCurrentTarget = ({ relatedTarget, currentTarget }) => {
    if (relatedTarget === null) return false;

    let node = relatedTarget.parentNode;

    while (node !== null) {
      if (node === currentTarget) return true;
      node = node.parentNode;
    }

    return false;
  };

  const onBlur = e => {
    if (!focusInCurrentTarget(e)) {
      setTimeout(() => {
        setShowDropDown(false);
      }, 500);
    }
  };

  return !hideCountryCode ? (
    <div className={style.contain} tabIndex={0} onBlur={onBlur}>
      <div className={style.container_wrapper} onClick={() => setShowDropDown(!showDropDown)}>
        {dialcodevalue ? <span>{dialcodevalue}</span> : <span className={style.container_placehder}>+000</span>}{' '}
        <BiChevronDownCircle />
      </div>
      {showDropDown && (
        <DropDownDiv
          {...{
            setShowDropDown,
            dialcodename,
            countriesOrderByActive,
            setCountries,
            onChangeCode
          }}
        />
      )}
    </div>
  ) : null;
};

const DropDownDiv = ({ setShowDropDown, dialcodename, countriesOrderByActive, setCountries, onChangeCode }) => {
  const inputRef = useRef('');
  const [searchTerm, setSearchTerm] = useState('');
  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    if (searchTerm) {
      const filtered = countryList.filter(
        country =>
          country.name.toLowerCase().includes(searchTerm?.toLowerCase().trim()) ||
          country.callingCodes[0].includes(searchTerm)
      );
      setCountries(filtered);
    } else {
      setCountries(countryList);
    }
  }, [searchTerm, setCountries]);

  useEffect(() => {
    inputRef.current && inputRef.current.focus();
  }, []);

  const setSearch = value => {
    setSearchTerm(value);
  };

  const handleEsc = e => {
    if (e.keyCode === 27 || e.key.toLowerCase() === 'escape') {
      setShowDropDown(false);
    }
  };
  const setPhoneWithDial = dialCode => {
    //set formik value in parent
    setFieldValue(dialcodename, dialCode);
  };

  return (
    <div className={style.DDContainer}>
      <div className={style.DDwrapper}>
        <input
          className={style.DDInput}
          type="text"
          placeholder="Search Country..."
          value={searchTerm}
          onChange={e => setSearch(e.target.value)}
          ref={inputRef}
          onKeyDown={handleEsc}
        />
        <FiSearch />
      </div>

      <div className={style.countrylist_wrapper}>
        {countriesOrderByActive.map((country, index) => {
          return (
            <li
              className={style.countryDiv}
              key={country.name + index}
              onClick={() => {
                setSearch(country.name);
                setPhoneWithDial(country.callingCodes[0]);
              }}
            >
              <span>{country.name}</span> <span className={style.dail_code}>{country.callingCodes[0]}</span>
            </li>
          );
        })}
      </div>
    </div>
  );
};
